module.exports = __webpack_public_path__ + "static/media/solution-3-big.fa49bccb.png";